import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClickEventNumbersEnum } from 'src/app/interfaces/clickEventNumbers';

@Component({
  selector: 'app-newsletter-modal',
  templateUrl: './newsletter-modal.component.html',
  styleUrl: './newsletter-modal.component.scss'
})
export class NewsletterModalComponent implements OnInit {
  @Input() petName: string = "[Pet Name]";
  public ClickEventNumbersEnum = ClickEventNumbersEnum;

  constructor(
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {}
}
